import React, { useEffect } from "react";
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, LocalizationV4 } from "@material-ui/data-grid";
//import Tooltip from '@material-ui/core/Tooltip';
import Grid from "@material-ui/core/Grid";
import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  getSpannungsebenen,
  selectSpannungsebeneListe,
  selectEditEntry,
  selectNewEntry,
  selectAktuellesSpannungsebene,
  selectViewMode,
  selectEditDirty,
  setEditEntry,
  updateAktuellesSpannungsebene,
  createSpannungsebene,
  updateSpannungsebene,
  setEbene,
  setKommentar,
  discardNew,
  discardChanges,
  startNewEntry,
  deleteSpannungsebene,
  setError,
  resetError,
  selectError,
  spannungsebeneDummy,
  selectListLoading,
  selectSorting,
  setSorting,
  resetViewMode,
  setSpannungswert
} from "./spannungsebenenSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { spannungsebene } from "../../../../utils/apiTypes";
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";

import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";


export const Spannungsebenen: React.FC = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  useEffect(() => {
    dispatch(getSpannungsebenen())
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    spannungsebeneSelectListe: spannungsebene[] = useAppSelector(selectSpannungsebeneListe),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuelleSpannungsebene: spannungsebene = useAppSelector(selectAktuellesSpannungsebene),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    { field: 'ebene', headerName: 'Ebene', flex: 2 },
    { field: 'spannungswert', headerName: 'Spannungswert', flex: 2 },
  ]

  function printTableSpannungsebene(data: spannungsebene[]) {
    return (
      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            columns={dataGridCols2}
            getRowId={(row) => row.ebene}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let se = spannungsebeneDummy;
              const currentSe = data.find(mst => mst.ebene == (param.row.ebene))
              if (currentSe)
                se = currentSe;
              if (!editEntry) dispatch(updateAktuellesSpannungsebene(se));
            }}
            loading={listLoading} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>

      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createSpannungsebene(aktuelleSpannungsebene)) : dispatch(updateSpannungsebene(aktuelleSpannungsebene)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuelleSpannungsebene.ebene == ""
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfRoutergeraet() {
    dispatch(deleteSpannungsebene(aktuelleSpannungsebene));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
      return (
        <div>
          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          {!aktuelleSpannungsebene.zugeordnet ?
            <Button
              variant="contained"
              onClick={() => setOpenDeleteDialog(true)}
              color="secondary"
              className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
            >
              Löschen
            </Button> : ""
          }
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>Routerstelle löschen</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie das Spannungsebene "' +
                  aktuelleSpannungsebene.ebene +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                variant="contained"
                onClick={confirmDeleteOfRoutergeraet}
                className={classes.confirmDeleteButton}
                style={{ minWidth: "120px", minHeight: "36px" }}
              >
                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }

  function printEdit() {
    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }}>
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4} >
              <Grid item container xs={12}>
                <Grid item md={3} >
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                    {newEntry ? "Neue Spannungsebene anlegen" : "Bearbeiten von Spannungsebene: " + aktuelleSpannungsebene.ebene.toString()}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} >
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="spannungsebene-ebene"
                    disabled={newEntry ? false : true}
                    label="Ebene"
                    error={validate(dispatch, setError, resetError, aktuelleSpannungsebene.ebene, "ebene")}
                    helperText={validateHelper(aktuelleSpannungsebene.ebene)}
                    variant="outlined"
                    onChange={(event) => dispatch(setEbene(event.target.value))}
                    value={aktuelleSpannungsebene.ebene.toString()}
                  />
                </FormControl>
              </Grid>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="spannungsebene-spannungswert"
                    disabled={editEntry ? false : true}
                    label="Spannungswert"
                    type="number"
                    error={validate(dispatch, setError, resetError, aktuelleSpannungsebene.spannungswert.toString(), "spannungswert")}
                    helperText={validateHelper(aktuelleSpannungsebene.spannungswert.toString())}
                    variant="outlined"
                    onChange={(event) => dispatch(setSpannungswert(Number(event.target.value)))}
                    value={aktuelleSpannungsebene.spannungswert.toString()}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id="spannungsebene-kommentar"
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuelleSpannungsebene.kommentar, "kommentar")}
                    helperText={validateHelper(aktuelleSpannungsebene.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuelleSpannungsebene.kommentar ? aktuelleSpannungsebene.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Spannungsebenen Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry ? true : false}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableSpannungsebene(spannungsebeneSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
